import { HTMLAttributes } from 'react';

import { TooltipProps } from 'vibo-ui/Tooltip';
import { IconmoonFont, SvgElement } from 'vibo-ui/Icon';

export interface LinkProps extends BaseButtonProps {
  href?: string;
  to?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

export interface BaseButtonProps extends HTMLAttributes<HTMLButtonElement | HTMLAnchorElement> {
  disabled?: boolean;
  className?: string;
}

export interface ButtonProps extends BaseButtonProps, LinkProps {
  displayType?: DisplayType;
  type?: ButtonType;
  shape?: ButtonShape;
  loading?: boolean;
  prefixIcon?: IconmoonFont | SvgElement;
  sufixIcon?: IconmoonFont | SvgElement;
  size?: ButtonSize;
  tooltipProps?: Omit<TooltipProps, 'children'>;
  subText?: string;
}

export enum ButtonDecor {
  'danger' = 'danger',
  'success' = 'success',
  'primaryColor' = 'primaryColor',
  'centrate' = 'centrate',
}

export type ButtonShape = 'default' | 'circle' | 'round';

export type ButtonType = 'submit' | 'button' | 'reset';

export type ButtonSize = 'xs' | 'sm' | 'lg' | 'xl' | 'xxl';

export type DisplayType = 'default' | 'primary' | 'link' | 'bordered' | 'white' | 'blueBorder';
